import React from 'react';
import { Leaf } from 'lucide-react';
import styles from './PaperPlatesHero.module.css';

const PaperPlatesHero = ({
  badge,
  scriptTitle,
  mainTitleLines,
  kicker,
  descriptions,
  features,
  imagePrimary,
  imageSecondary,
  stampLabel = 'Food Grade',
}) => (
  <section className={styles.heroSection}>
    <div className={styles.leafGlow} aria-hidden="true" />

    <div className={styles.inner}>
      <div className={styles.layout}>
        <div className={styles.copyCol}>
          <span className={styles.badge}>{badge}</span>

          <div className={styles.titleBlock}>
            <span className={styles.eyebrow}>{scriptTitle}</span>
            <h1 className={styles.title}>
              {mainTitleLines[0]}{' '}
              <span className={styles.titleAccent}>{mainTitleLines[1]}</span>
            </h1>
          </div>

          {kicker && <p className={styles.kicker}>{kicker}</p>}

          <div className={styles.bodyCopy}>
            {descriptions.slice(0, 2).map((text, index) => (
              <p key={index} className={styles.paragraph}>
                {text}
              </p>
            ))}
          </div>

          {features?.length > 0 && (
            <ul className={styles.featureRow}>
              {features.map((feature, index) => (
                <li key={index} className={styles.featureChip}>
                  <Leaf size={11} aria-hidden="true" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className={styles.plateCol}>
          <div className={styles.plateStage}>
            {imageSecondary && (
              <figure className={styles.plateBack}>
                <img src={imageSecondary.src} alt={imageSecondary.alt} />
              </figure>
            )}

            {imagePrimary && (
              <figure className={styles.plateFront}>
                <img src={imagePrimary.src} alt={imagePrimary.alt} />
              </figure>
            )}

            {stampLabel && (
              <div className={styles.gradeBadge}>
                <Leaf size={13} aria-hidden="true" />
                <span>{stampLabel}</span>
              </div>
            )}

            <span className={styles.ringAccent} aria-hidden="true" />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default PaperPlatesHero;
